import { render, staticRenderFns } from "./CommonImageCard.vue?vue&type=template&id=6d8d3890&"
import script from "./CommonImageCard.vue?vue&type=script&lang=js&"
export * from "./CommonImageCard.vue?vue&type=script&lang=js&"
import style0 from "./CommonImageCard.vue?vue&type=style&index=0&id=6d8d3890&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports